import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import namespace resources (can be code-split later for performance)
import loansEn from './locales/en/loans.json';
import loansFr from './locales/fr/loans.json';
import loansAr from './locales/ar/loans.json';
import commonEn from './locales/en/common.json';

// NOTE: For now we eagerly bundle the loans namespace to unblock Phase 1.
// In later phases we can lazy-load additional namespaces (applications, accounts, collections, products, reports).
// Keep resources shape: { [lng]: { [namespace]: { key: value } } }
const resources = {
    en: { loans: loansEn, common: commonEn },
    fr: { loans: loansFr },
    ar: { loans: loansAr }
};

if (!i18n.isInitialized) {
    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources,
            fallbackLng: 'en',
            supportedLngs: ['en', 'fr', 'ar'],
            ns: ['loans', 'common'],
            defaultNS: 'loans',
            load: 'languageOnly',
            interpolation: {
                escapeValue: false
            },
            detection: {
                // Rely on browser language, querystring, localStorage (default order from detector)
                caches: ['localStorage'],
            },
            react: {
                useSuspense: false
            }
        });

    // RTL handling (guard for non-DOM test environments)
    const applyDir = (lng) => {
        if (typeof document === 'undefined') return;
        const isRTL = lng === 'ar';
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.documentElement.lang = lng;
    };
    applyDir(i18n.language);

    i18n.on('languageChanged', (lng) => {
        applyDir(lng);
    });
}

export default i18n;
